import { Tabs, TabsProps } from "antd";
const items: TabsProps["items"] = [
  {
    key: "1",
    label: `Custom`,
  },
  {
    key: "2",
    label: `Weekly`,
  },
  {
    key: "3",
    label: `Mothly`,
  },
  {
    key: "4",
    label: `Yearly`,
  },
];

type PropsType = {
  option: string;
  setOption: React.Dispatch<React.SetStateAction<string>>;
};
export const RightTab = ({ option, setOption }: PropsType) => {
  const onChange = (key: string) => {
    setOption(key);
  };
  return (
    <Tabs
      defaultActiveKey={option}
      items={items}
      onChange={onChange}
      style={{ width: "min-content", float: "right" }}
    />
  );
};
